import React from "react";
import GalleryPreview from "../components/GalleryPreview"; 

export default function GalleryPage() {
  return (
    <div>
      <GalleryPreview />
    </div>
  );
}
